var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0494 6.21719C16.9566 5.51479 16.1682 4.39058 15.9221 3.08086C15.869 2.79796 15.8395 2.50653 15.8395 2.2085H12.3518L12.3459 15.9882C12.2876 17.5316 10.9992 18.7699 9.41993 18.7699C8.92906 18.7699 8.46692 18.6492 8.05989 18.4377C7.12656 17.9538 6.48768 16.9894 6.48768 15.88C6.48768 14.2862 7.80324 12.9893 9.41954 12.9893C9.72146 12.9893 10.0108 13.0386 10.2844 13.1228V9.61274C10.001 9.57432 9.7132 9.55104 9.41954 9.55104C5.8799 9.55104 3 12.3897 3 15.88C3 18.0209 4.08488 19.9158 5.74094 21.0614C6.78331 21.7836 8.05202 22.2085 9.41993 22.2085C12.96 22.2085 15.8395 19.3694 15.8395 15.88V8.89211C17.2074 9.85994 18.8835 10.4304 20.6923 10.4304V6.99176C19.718 6.99176 18.8107 6.70654 18.0494 6.21719Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokLogo);
export default __webpack_public_path__ + "static/media/tiktok-logo.2cb85ff8b2646a50839114a1790d124e.svg";
export { ForwardRef as ReactComponent };